export default __webpack_public_path__ + "static/media/knowledge2.b44f7c89.png";